import { render } from "./WeekdayClassFee.vue?vue&type=template&id=56abe652&scoped=true"
import script from "./WeekdayClassFee.vue?vue&type=script&lang=js"
export * from "./WeekdayClassFee.vue?vue&type=script&lang=js"

import "./WeekdayClassFee.vue?vue&type=style&index=0&id=56abe652&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56abe652"]])

export default __exports__